import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import SvgImage from "../../SvgImage";
import { ContextAwareToggle } from "../../accordion";

type Props = {
  handleOnPressEdit: (tabName: IActiveTabs) => void;
};

const ReviewTaxPaidDetails: React.FC<Props> = (props: Props) => {
  const { handleOnPressEdit } = props;

  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      <Accordion.Item eventKey="review-file-5">
        <Accordion.Header>
          <div className="btn-content">
            <SvgImage imgId="taxes-paid-information" />
            <h4 className="mb-0">Taxes Paid, TDS and TCS</h4>
          </div>
          <PreventEditComponent>
            <span
              role="button"
              className="btn btn-link"
              onClick={() => handleOnPressEdit("deductions")}
            >
              Edit
            </span>
          </PreventEditComponent>
        </Accordion.Header>
        <Accordion.Body>
          <hr />
          <Accordion className="accordion-sm">
            <Accordion.Item eventKey="deductions-0">
              <ContextAwareToggle eventKey="deductions-0" isChild={true}>
                <div className="btn-content justify-content-between">
                  <p className="leading-para fw-bold mb-0">Tax Paid Breakup</p>
                  <p className="leading-para fw-bold mb-0">
                    <PriceDisplay price={values.TaxPaid.TaxesPaid.TotalTaxesPaid} />
                  </p>
                </div>
              </ContextAwareToggle>
              <Accordion.Body>
                <section>
                  <dl className="eds-list eds-dl eds-inline-between">
                    <RenderListItem title="TDS on Salary" total={values.TotalTDSonSalaries} />

                    <RenderListItem
                      title="TDS on Non Salary"
                      total={values.TotalTDSonOthThanSals}
                    />

                    <RenderListItem
                      title="TDS on Sale or Rent of Immovable Property"
                      total={values.TotalTDS3Details}
                    />

                    <RenderListItem title="Taxes collected at source" total={values.TotalSchTCS} />

                    <RenderListItem title="Self tax payments" total={values.TotalSelfTaxPayments} />
                  </dl>
                </section>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <dl className="eds-list eds-dl eds-inline-between">
            <div className="eds-list--item eds-list--item-total">
              <dt>Total Tax Paid:</dt>
              <dd>
                <PriceDisplay price={values.TaxPaid.TaxesPaid.TotalTaxesPaid} />
              </dd>
            </div>
          </dl>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default ReviewTaxPaidDetails;

const RenderListItem = ({ total, title }: { total: number; title: string }) => {
  return (
    <>
      {total ? (
        <div className="eds-list--item">
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={total} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
